export default __webpack_public_path__ + "static/media/movie-logo.2d82eac2.svg";